import { Divider, Stack, Switch, Typography } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';

import type { BackupVault } from '@/data/vaults/backupVault';

import { AwsKmsTextField } from './awsKmsTextField';
import { GcpKmsTextField } from './gcpKmsTextField';

import { Accordion, AccordionDetails, AccordionSummary } from '../accordion';

export const VaultAdvanceOptions = ({
  disabled,
  backupVault,
  setBackupVault,
  customKey,
  setCustomKey,
}: {
  disabled: boolean;
  backupVault: BackupVault;
  setBackupVault: (data: BackupVault) => void;
  customKey: boolean;
  setCustomKey: (customKey: boolean) => void;
}) => {
  return (
    <Stack gap='12px'>
      <Divider sx={{ margin: '0 -40px' }} />
      <Accordion>
        <AccordionSummary>
          <Typography variant='h4'>Advanced options</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ paddingRight: '0' }}>
          <Stack
            gap='16px'
            divider={<Divider sx={{ borderStyle: 'dashed' }} />}
          >
            <KmsKeyOption
              disabled={disabled}
              backupVault={backupVault}
              setBackupVault={setBackupVault}
              customKey={customKey}
              setCustomKey={setCustomKey}
            />
          </Stack>
        </AccordionDetails>
      </Accordion>
      <Divider sx={{ margin: '0 -40px' }} />
    </Stack>
  );
};

const KmsKeyOption = ({
  disabled,
  backupVault,
  setBackupVault,
  customKey,
  setCustomKey,
}: {
  disabled: boolean;
  backupVault: BackupVault;
  setBackupVault: (data: BackupVault) => void;
  customKey: boolean;
  setCustomKey: (customKey: boolean) => void;
}) => {
  const isGcp = backupVault.vaultAttributes.cloudProvider === Provider.Gcp;

  const clearEncryptionKey = () => {
    if (isGcp) {
      setBackupVault({
        ...backupVault,
        vaultAttributes: {
          ...backupVault.vaultAttributes,
          gcp: {
            ...backupVault.vaultAttributes.gcp,
            encryptionKey: '',
          },
        },
      });
    } else {
      setBackupVault({
        ...backupVault,
        vaultAttributes: {
          ...backupVault.vaultAttributes,
          aws: {
            ...backupVault.vaultAttributes.aws,
            encryptionKey: '',
          },
        },
      });
    }
  };

  return (
    <Stack className='w-full' gap='24px'>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Stack direction='row' gap='12px' alignItems='center'>
          <Switch
            size='small'
            disabled={disabled}
            checked={customKey}
            onChange={(event) => {
              setCustomKey(event.target.checked);
              if (!event.target.checked) {
                clearEncryptionKey();
              }
            }}
          />
          <Typography>
            {isGcp ? 'Use my own Cloud KMS key' : 'Use my own KMS key'}
          </Typography>
        </Stack>
        {customKey && (
          <Stack width='400px' justifyContent='flex-end'>
            {isGcp ? (
              <GcpKmsTextField
                backupVault={backupVault}
                setBackupVault={setBackupVault}
              />
            ) : (
              <AwsKmsTextField
                backupVault={backupVault}
                setBackupVault={setBackupVault}
              />
            )}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
